import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const positionStore = {
  namespaced: true,
  state: {
    positionList: [],
    selectedPosition: {
      addDriver: 0,
      announcement: 0,
      airportTransfer: 0,
      callCar: 0,
      customer: 0,
      defaultDriverService: 0,
      dispatchArea: 0,
      driverMessage: 0,
      driverMonitor: 0,
      driverTrajectory: 0,
      editDriver: 0,
      instanceTransactionRecord: 0,
      landmark: 0,
      mobilePayment: 0,
      positionId: -1,
      positionManagement: 0,
      positionName: '',
      reservation: 0,
      saveHailBill: 0,
      saveReservation: 0,
      scheduledArea: 0,
      scheduledBoard: 0,
      store: 0,
      transaction: 0,
      transactionStatistics: 0,
      userBehavior: 0,
      userDeletion: 0,
      userManagement: 0,
    },
  },
  getters,
  mutations,
  actions,
}

export default positionStore



// WEBPACK FOOTER //
// ./src/store/positionStore/index.js